var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarFavourite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ICON",
    height: 512,
    viewBox: "0 0 32 32",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m29.889 12.472c-.245-.729-.857-1.252-1.6-1.366l-7.187-1.103-3.221-6.834c-.336-.721-1.029-1.168-1.807-1.168-.778 0-1.471.448-1.807 1.166l-3.222 6.837-7.187 1.103c-.742.114-1.355.638-1.6 1.366-.252.751-.069 1.568.477 2.13l5.23 5.382-1.236 7.612c-.13.802.194 1.584.847 2.043.34.239.734.36 1.13.36.327 0 .654-.083.955-.249l6.396-3.568 6.431 3.568c.664.369 1.463.326 2.084-.111.653-.458.977-1.241.847-2.042l-1.236-7.612 5.23-5.382c.546-.562.729-1.378.477-2.13z",
    fill: "#ffcb2b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFavourite);
export default __webpack_public_path__ + "static/media/star-favourite.6b9fbcc8bd91c181d53ff26fba9b6356.svg";
export { ForwardRef as ReactComponent };